import { useRef, useState, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import { siteboardAction } from '../actions/defaultActions';
import { SET_DELETE_DAILY_REPORT_DIALOGUE_ID, DELETE_DAILY_REPORT } from '../actions/types';
import PopupWindow from './PopupWindow';

const DeleteDailyReportDialogue = ({ siteboardAction, _projects, _dailyReports, _deleteDailyReportDialogueId }) => {
  const inputRef = useRef(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_DELETE_DAILY_REPORT_DIALOGUE_ID, { dailyReportId: '00000000-0000-0000-0000-000000000000' });
  }, [siteboardAction]);

  // focus input when component is shown
  useEffect(() => {
    //try { inputRef.current.focus(); } catch(error) {}
  }, []);

  const selectedDailyReport = _dailyReports[_deleteDailyReportDialogueId];
  if(selectedDailyReport === undefined) return (<></>);

  const selectedProject = _projects[selectedDailyReport.projectId];
  if(selectedProject === undefined) return (<></>);

  return (
    <PopupWindow title='Delete Daily Report' closeDialogue={closeDialogue} bgStyle='bg-[#333333]'>
      <div className='max-w-[400px] text-white'>
        <div className=''>
          Delete this daily report for <b>{selectedProject.name}</b> on <b>{selectedDailyReport.date}</b>? This action cannot be undone.
        </div>
        <div className='mt-5'>
          To avoid unintentional deletions, we ask you to provide additional confirmation.
        </div>
        <div className='font-bold mt-5'>
          To confirm this deletion, type "confirm".
        </div>
        <div className='mt-1'>
          <input 
            ref={inputRef}
            className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
            type='text' 
            value={deleteConfirmation}
            onChange={(event) => { 
              setDeleteConfirmation(event.target.value); 
            }}
          />
        </div>
        <div className='flex'>
          <div className='flex flex-col justify-center mt-5'>
            <div className='flex justify-center'>
            {deleteConfirmation.toLowerCase() === 'confirm' ?
              <>
                {/* real delete button  */}
                <button  
                  className='bg-[#cc1b2d] hover:bg-[#f12035] py-[9px] px-[44px] text-white font-bold select-none rounded-lg' 
                  onClick={() => {
                    if(selectedDailyReport === null) return;
                    const onSuccess = (output) => { closeDialogue(); }
                    siteboardAction(DELETE_DAILY_REPORT, { 
                      projectId: selectedProject.id, 
                      subscriptionId: selectedProject.subscriptionId,
                      dailyReportId: selectedDailyReport.id 
                    }, onSuccess);
                  }}
                >
                  Delete Daily Report
                </button>
              </>
              :
              <>
                {/* fake delete button  */}
                <div className='bg-gray-500 font-bold text-gray-300 py-[9px] px-[44px] text-black select-none rounded-lg'>Delete Daily Report</div>
              </>
            }
            </div>
          </div>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _projects: state.serverSynced.projects,
  _dailyReports: state.serverSynced.dailyReports,
  _deleteDailyReportDialogueId: state.localEphemeral.deleteDailyReportDialogueId,
}};
export default connect(mapStateToProps, { siteboardAction })(DeleteDailyReportDialogue);
